<fadv-layout>
    <fadv-layout-main id="layoutMain">
      <div id="summaryContainerMobile" class="summaryContainerMobile">
        <fadv-box pb="medium">
          <fadv-card>
            <fadv-card-header>
              <div class="card-header-formatting">
                <fadv-box ph="medium" pv="x-small">
                  <fadv-typography style="text-align: center" type="heading-small" variant="white">
                    Summary
                  </fadv-typography>
                </fadv-box>
              </div>
            </fadv-card-header>
            <fadv-card-body>
              <fadv-grid>
                <fadv-grid-row>
                  <fadv-grid-col style="padding-top: 16px; margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography>Package Total: {{ packagePrice }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
                <!-- <fadv-grid-row>
                  <fadv-grid-col style="margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography>Package Tax: {{ packageTax }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row> -->
                <fadv-grid-row>
                  <fadv-grid-col style="padding-top: 16px;margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography>Add-On Total: {{ addOnPrice }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
                <!-- <fadv-grid-row>
                  <fadv-grid-col style="margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography>Add-On Tax: {{ addOnTax }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row> -->
                <fadv-grid-row>
                  <fadv-grid-col>
                    <fadv-box>
                      <fadv-divider></fadv-divider>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
                <fadv-grid-row>
                  <fadv-grid-col style="padding-bottom:16px; margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography variant="primary">Tax Total: {{ totalTax | currency }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
                <fadv-grid-row>
                  <fadv-grid-col style="padding-bottom:16px; margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography variant="primary">Order Total: {{ billingTotal }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
              </fadv-grid>
            </fadv-card-body>
          </fadv-card>
        </fadv-box>
      </div>
  
      <fadv-grid>
        <fadv-grid-row>
          <fadv-grid-col [col]="{ sm: 12, md: 12, l: 12, xl: 12 }">
            <fadv-card>
              <fadv-card-header>
                <div class="card-header-formatting">
                  <fadv-box p="medium">
                    <fadv-typography style="text-align: center" type="heading-small" variant="white">
                      Place Your Order
                    </fadv-typography>
                    <fadv-typography style="text-align: center" type="paragraph-medium" variant="white">
                      Once Your Payment is Submitted, We Will Verify Your Business and Begin the Screening Process.
                    </fadv-typography>
                  </fadv-box>
                </div>
              </fadv-card-header>
              <fadv-card-body>
                <fadv-grid>
                  <fadv-grid-row>
                    <fadv-grid-col>
                        <fadv-box pt="medium">
                          <fadv-credit-card hoist="true" #fadvCreditCard></fadv-credit-card>
                        </fadv-box>
                        <fadv-box pt="medium">
                          <app-payment-extended hoist="true" #paymentExtended></app-payment-extended>
                        </fadv-box>
                    </fadv-grid-col>
                  </fadv-grid-row>
                  <fadv-grid-row>
                    <fadv-grid-col>
                      <fadv-box p="medium">
                        <fadv-typography>
                          By clicking "Save Payment" I hereby, authorize and request First Advantage to charge my credit
                          card
                          for balances due for services rendered which
                          may include later <a href="https://fadv.com/smallbusiness/support/" target="_new">incurred
                            additional
                            court access fees</a> related to the services. This authorization will remain in effect for a
                          period of 90 days.
                        </fadv-typography>
                      </fadv-box>
                      <fadv-box p="small" pl="medium">
                        <fadv-typography variant="primary"> <strong>Today's Date: {{ date | date: 'longDate'
                            }}</strong>
                        </fadv-typography>
                      </fadv-box>
                        <fadv-box p="x-small" class="fadv-align-center">
                          <fadv-alternate-alert #errorBilling variant='danger'>{{ errorMessage }}</fadv-alternate-alert>
                      </fadv-box>
                    </fadv-grid-col>
                  </fadv-grid-row>
                  <fadv-grid-row>
                    <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
                      <fadv-box p="medium">
                        <fadv-button style="width: 100%" size="large" (click)="onCancel()"
                        name="partner-payment-back-button">Back
                        </fadv-button>
                      </fadv-box>
                    </fadv-grid-col>
                    <fadv-grid-col [col]="{ xs: 12, sm: 12, md: 12, l: 12, xl: 6 }">
                      <fadv-box  p="medium">
                        <fadv-button [loading]="loading" [active]="loading" [disabled]="loading" size="large"
                          variant="primary" type="submit" style="width: 100%" (click)="onSubmit()" name="partner-save-payment-button">
                          Save Payment
                        </fadv-button>
                      </fadv-box>
                    </fadv-grid-col>
                  </fadv-grid-row>
                </fadv-grid>
              </fadv-card-body>
            </fadv-card>
          </fadv-grid-col>
        </fadv-grid-row>
      </fadv-grid>
  
  
      <fadv-grid>
        <fadv-grid-row>
          <fadv-grid-col>
            <fadv-box pt="large" pl="x-small">
              <fadv-typography type="paragraph-small">**First Advantage will not charge your card until the background
                check
                report has completed.</fadv-typography>
            </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
      </fadv-grid>
  
  
      <div class="bottomBumper" id="bottomBumper"></div>
  
      <!--Credit Card Form-->
  
    </fadv-layout-main>
  
    <!--Ordery summary card -->
    <fadv-layout-section pl="50px" position="right">
      <div id="summaryContainer" class="summaryContainer">
        <fadv-box pl="50px">
          <fadv-card>
            <fadv-card-header>
              <div class="card-header-formatting">
                <fadv-box ph="medium" pv="x-small">
                  <fadv-typography style="text-align: center" type="heading-small" variant="white">
                    Summary
                  </fadv-typography>
                </fadv-box>
              </div>
            </fadv-card-header>
            <fadv-card-body>
              <fadv-grid>
                <fadv-grid-row>
                  <fadv-grid-col style="padding-top: 16px; margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography>Package Total: {{ packagePrice }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
                <fadv-grid-row>
                  <fadv-grid-col style="margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography>Package Tax: {{ packageTax }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
                <fadv-grid-row>
                  <fadv-grid-col style="padding-top: 16px;margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography>Add-On Total: {{ addOnPrice }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
                <fadv-grid-row>
                  <fadv-grid-col style="margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography>Add-On Tax: {{ addOnTax }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
                <fadv-grid-row>
                  <fadv-grid-col>
                    <fadv-box>
                      <fadv-divider></fadv-divider>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
                <fadv-grid-row>
                  <fadv-grid-col style="padding-bottom:16px; margin-right:30px;" alignment="right">
                    <fadv-box>
                      <fadv-typography variant="primary">Order Total: {{ billingTotal }}</fadv-typography>
                    </fadv-box>
                  </fadv-grid-col>
                </fadv-grid-row>
              </fadv-grid>
            </fadv-card-body>
          </fadv-card>
        </fadv-box>
      </div>
    </fadv-layout-section>
  </fadv-layout>
  
  <div #bumper id="bumper" class="bumper">
  </div>